import React, { useEffect, useContext, useState } from "react";
import { toast } from "react-toastify";
import UserContext from "../context/UserContext";
import styles from "../Styles/Notification.module.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Notificationspanel = () => {
  const { user } = useContext(UserContext);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/app/whatsapp/notifications/${user.email}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setNotifications(data.data || []);
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "Failed to fetch notifications");
      }
    } catch (error) {
      toast.error("Network error while fetching notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.email && user?.token) {
      fetchNotifications();
    }
  }, [user]);

  return (
    <div>
        <h1 className={styles.header}>Notifications</h1>
      <div className={styles.modalContainer}>
        

        {loading && <p className={styles.loading}>Loading...</p>}

        {!loading && notifications.length === 0 && (
          <p className={styles.noNotifications}>No notifications found.</p>
        )}

        <div className={styles.notificationsList}>
          {notifications.map((notification, index) => (
            <div key={index} className={styles.card}>
              <p className={styles.message}>{notification.title}</p>
              <p className={styles.message}>{notification.message}</p>
              <small className={styles.timestamp}>
                {new Date(notification.created_at).toLocaleString()}
              </small>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Notificationspanel;
